import { Link } from 'react-router-dom';

export default function BrandIntro() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-6">
          品牌介绍
        </h2>
        <div className="flex flex-col gap-4 text-sm md:text-base text-foreground-700 leading-relaxed">
          <p>
            <strong className="text-foreground-900">禁漫天堂</strong>成立于2018年，是国内领先的成人漫画阅读平台。我们致力于为全球华语用户提供优质、丰富、安全的漫画阅读服务，涵盖日漫、韩漫、国漫、3D漫画等多元类型。
          </p>
          <p>
            经过多年的发展，禁漫天堂已积累了超过<strong className="text-foreground-900">10万部</strong>漫画资源，覆盖恋爱、奇幻、动作、悬疑、科幻等数十个题材分类，满足不同用户的多样化阅读需求。平台注册用户突破<strong className="text-foreground-900">500万</strong>，日均活跃用户超过<strong className="text-foreground-900">80万</strong>。
          </p>
          <p>
            禁漫天堂始终坚持<strong className="text-foreground-900">用户至上</strong>的服务理念，不断优化产品体验。我们自主研发的阅读引擎支持多种阅读模式，APP客户端提供离线下载、智能推荐、更新提醒等便捷功能。同时，我们为VIP会员提供无广告纯净阅读、高清画质等专属权益。
          </p>
          <p>
            在内容方面，禁漫天堂与国内外多家漫画出版社和创作者建立了合作关系，持续引进优质正版漫画资源。我们同时设立了国漫专区，积极扶持国产原创漫画的发展，为本土创作者提供展示才华的舞台。
          </p>
          <p>
            安全与隐私保护是禁漫天堂始终关注的重点。我们采用业界领先的加密技术保护用户数据，严格遵守相关法律法规，确保用户能够放心使用平台服务。
          </p>
          <Link
            to="/category/hot"
            className="inline-flex items-center gap-1.5 text-primary-600 hover:text-primary-700 font-medium transition-colors mt-2"
          >
            立即开始阅读 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}